import { Control, Controller } from 'react-hook-form';
import {
  FormControl,
  Typography,
} from '@mui/material';

export const Expiration = (props: { control: Control<any> }) => {
  return (
    <FormControl component="fieldset" margin="dense">
      <Controller
        rules={{ required: true }}
        control={props.control}
        defaultValue="604800"
        name="expiration"
        render={({ field }) => (
          <>            {/* Hidden input to maintain the form value */}
            <input type="hidden" {...field} />
            <Typography variant="body1" color="textSecondary">
              The encrypted message will be deleted once viewed or automatically after one week
            </Typography>
          </>
        )}
      />
    </FormControl>
  );
};
export default Expiration;
